"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.PlannerWeek = exports.PlannerContainer = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _grid = require("@rebass/grid");
var _eachDayOfInterval = _interopRequireDefault(require("date-fns/eachDayOfInterval"));
var _eachWeekOfInterval = _interopRequireDefault(require("date-fns/eachWeekOfInterval"));
var _endOfMonth = _interopRequireDefault(require("date-fns/endOfMonth"));
var _endOfWeek = _interopRequireDefault(require("date-fns/endOfWeek"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));
var _isWithinInterval = _interopRequireDefault(require("date-fns/isWithinInterval"));
var _nl = _interopRequireDefault(require("date-fns/locale/nl"));
var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));
var _startOfWeek = _interopRequireDefault(require("date-fns/startOfWeek"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _customizationClassNames = require("../../constants/customizationClassNames");
var _theme = require("../../constants/theme");
var _useWeekdays = _interopRequireDefault(require("../../hooks/useWeekdays"));
var _Title = _interopRequireDefault(require("../primitive/Title"));
var _PlannerDay = _interopRequireWildcard(require("./PlannerDay"));
var _excluded = ["date", "period", "locale", "computeDayProps", "onDayClick", "onDayMouseLeave", "onDayMouseEnter", "loading", "isSelecting", "periodColor", "defaultFontColor"]; // eslint-disable-next-line no-restricted-imports
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
// there's an issue with date-fns sometimes randomly throwing an error when using `eachDayOfInterval` eventhough it's valid.
// still not sure what exactly causes it.
// https://github.com/date-fns/date-fns/issues/1626
var getDaysOfInterval = function getDaysOfInterval(interval) {
  try {
    return (0, _eachDayOfInterval["default"])(interval);
  } catch (error) {
    if ((0, _isSameDay["default"])(interval.start, interval.end)) {
      return [new Date(interval.start)];
    }
    return [];
  }
};
function PlannerMonth(_ref, ref) {
  var _props$className;
  var date = _ref.date,
    period = _ref.period,
    _ref$locale = _ref.locale,
    locale = _ref$locale === void 0 ? _nl["default"] : _ref$locale,
    computeDayProps = _ref.computeDayProps,
    onDayClick = _ref.onDayClick,
    onDayMouseLeave = _ref.onDayMouseLeave,
    onDayMouseEnter = _ref.onDayMouseEnter,
    _ref$loading = _ref.loading,
    loading = _ref$loading === void 0 ? false : _ref$loading,
    isSelecting = _ref.isSelecting,
    periodColor = _ref.periodColor,
    defaultFontColor = _ref.defaultFontColor,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var start = (0, _startOfMonth["default"])(date);
  var end = (0, _endOfMonth["default"])(date);
  var weekOpts = {
    locale: locale,
    weekStartsOn: 1
  };
  var weekdays = (0, _useWeekdays["default"])(weekOpts);
  var weeks = (0, _eachWeekOfInterval["default"])({
    start: start,
    end: end
  }, weekOpts);
  var fallsInMonth = (0, _react.useCallback)(function (monthDay) {
    return (0, _isWithinInterval["default"])(monthDay, {
      start: start,
      end: end
    });
  }, [end, start]);
  return /*#__PURE__*/_react["default"].createElement(PlannerContainer, Object.assign({}, props, {
    className: "".concat((_props$className = props.className) !== null && _props$className !== void 0 ? _props$className : '', " ").concat(_customizationClassNames.CLASS_PLANNER_MONTH),
    ref: ref
  }), /*#__PURE__*/_react["default"].createElement(_grid.Flex, {
    width: 1,
    justifyContent: "center",
    mb: 5
  }, /*#__PURE__*/_react["default"].createElement(_Title["default"], {
    variant: "small"
  }, (0, _format["default"])(date, "MMMM \u2018yy", {
    locale: locale
  }))), /*#__PURE__*/_react["default"].createElement(PlannerGrid, null, /*#__PURE__*/_react["default"].createElement(PlannerWeek, null, weekdays.map(function (weekday) {
    return /*#__PURE__*/_react["default"].createElement(PlannerWeekday, {
      key: +weekday
    }, (0, _format["default"])(weekday, 'EEEEEE', {
      locale: locale
    }));
  })), weeks.map(function (weekStart) {
    var weekInterval = {
      start: (0, _startOfWeek["default"])(new Date(weekStart), weekOpts),
      end: (0, _endOfWeek["default"])(new Date(weekStart), weekOpts)
    };
    return /*#__PURE__*/_react["default"].createElement(PlannerWeek, {
      key: +weekStart
    }, getDaysOfInterval(weekInterval).map(function (weekday) {
      if (loading) {
        return /*#__PURE__*/_react["default"].createElement(_PlannerDay["default"], {
          key: +weekday,
          variant: "loading"
        });
      }
      if (fallsInMonth(weekday)) {
        var dayProps = computeDayProps === null || computeDayProps === void 0 ? void 0 : computeDayProps(weekday);
        var _ref2 = dayProps !== null && dayProps !== void 0 ? dayProps : {},
          variant = _ref2.variant;
        var callbackVars = {
          day: weekday,
          variant: variant
        };
        return /*#__PURE__*/_react["default"].createElement(_PlannerDay["default"], Object.assign({
          key: +weekday,
          date: weekday,
          isSelecting: isSelecting,
          onClick: function onClick() {
            if (variant && _PlannerDay.clickables.includes(variant)) {
              onDayClick === null || onDayClick === void 0 ? void 0 : onDayClick(callbackVars);
            }
          },
          onMouseEnter: function onMouseEnter() {
            if (variant && _PlannerDay.hoverables.includes(variant)) {
              onDayMouseEnter === null || onDayMouseEnter === void 0 ? void 0 : onDayMouseEnter(callbackVars);
            }
          },
          onMouseDown: function onMouseDown() {
            return onDayMouseLeave === null || onDayMouseLeave === void 0 ? void 0 : onDayMouseLeave(callbackVars);
          }
        }, dayProps));
      }
      // outside the month, a ghost day if you will
      return /*#__PURE__*/_react["default"].createElement(_PlannerDay["default"], {
        key: +weekday
      });
    }));
  })));
}
var _default = exports["default"] = (0, _react.forwardRef)(PlannerMonth);
var PlannerWeek = exports.PlannerWeek = _styledComponents["default"].div.attrs({
  className: _customizationClassNames.CLASS_PLANNER_WEEK
}).withConfig({
  displayName: "PlannerMonth__PlannerWeek",
  componentId: "sc-1jph0mk-0"
})(["width:100%;display:flex;+ div{margin-top:0.4rem;}"]);
var PlannerContainer = exports.PlannerContainer = (0, _styledComponents["default"])(_grid.Box).withConfig({
  displayName: "PlannerMonth__PlannerContainer",
  componentId: "sc-1jph0mk-1"
})(["flex-shrink:0;width:100%;@media screen and (min-width:", "){width:calc(50% - (var(--monthGap) * 1px) / 2);}@media screen and (min-width:", "){width:calc(100% / 3 - (var(--monthGap) * 1px * 2) / 3);}"], function (_ref3) {
  var theme = _ref3.theme;
  return theme.mediaQueries.s;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.mediaQueries.xl;
});
var PlannerGrid = _styledComponents["default"].div.withConfig({
  displayName: "PlannerMonth__PlannerGrid",
  componentId: "sc-1jph0mk-2"
})(["display:flex;flex-direction:column;font-family:", ";"], function (_ref5) {
  var theme = _ref5.theme;
  return theme.fontFamily.body;
});
var PlannerWeekday = _styledComponents["default"].div.withConfig({
  displayName: "PlannerMonth__PlannerWeekday",
  componentId: "sc-1jph0mk-3"
})(["width:calc(100% / 7);color:", ";font-weight:lighter;display:flex;justify-content:center;height:2.4rem;margin-bottom:", ";", ";font-weight:500;& + &{margin-left:0.4rem;}"], function (_ref6) {
  var theme = _ref6.theme;
  return theme.colors.neutral['60'];
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.spacing['30_Small'];
}, function (_ref8) {
  var theme = _ref8.theme;
  return (0, _theme.getFontCss)(theme.fontSizes.body.small);
});
//# sourceMappingURL=PlannerMonth.js.map